<form class="ui form" [formGroup]="modelForm">
  <app-tabset>
    <div class="ui four item menu">
      <a class="item" appTabHeader="1" [isActive]="true">Display</a>
      <a class="item" appTabHeader="2">Settings</a>
      <a class="item" appTabHeader="3">Choices</a>
      <a class="item" appTabHeader="4">Skip Logic</a>
    </div>
    <div class="ui segment" appTabContent="1">
      <div *ngIf="model">
        <div class="field">
          <label>Label</label> <span data-toggle="tooltip" data-placement="right"
            title="The label for this field that will appear next to it"><i
              class="glyphicon glyphicon-question-sign text-muted"></i></span>
          <input formControlName="label" (ngModelChange)="doSomething($event)" type="text" [(ngModel)]="model.label"
            class="form-control" />
          <span [ngClass]="{ 'has-error' : modelForm.get('label').dirty	&&	!modelForm.get('label').valid}"
            *ngIf="modelForm.get('label').dirty	&&	!modelForm.get('label').valid  && !modelForm.get('label').pending">
            <span class="help-block" *ngIf="modelForm.get('label').hasError('required')">This field is required.</span>
          </span>
        </div>
        <div class="field">
          <label>Name</label> <span data-toggle="tooltip" data-placement="right"
            title="The name of the field, must be unique"><i
              class="glyphicon glyphicon-question-sign text-muted"></i></span>
          <input formControlName="name" type="text" class="form-control" inputcase />
          <span [ngClass]="{ 'has-error' : modelForm.get('name').dirty	&&	!modelForm.get('name').valid}"
            *ngIf="modelForm.get('name').dirty	&&	!modelForm.get('name').valid  && !modelForm.get('name').pending">
            <span class="help-block" *ngIf="modelForm.get('name').hasError('columnName')">Only alphanumeric and
              underscore(_) characters are allowed.</span>
            <span class="help-block" *ngIf="modelForm.get('name').hasError('required')">This field is required.</span>
          </span>
          <small class="red" *ngIf="error">This fieldname already exist within your app</small>
        </div>
        <div class="field">
          <label>Hint</label> <span data-toggle="tooltip" data-placement="right"
            title="Brief explaination for fill this field"><i
              class="glyphicon glyphicon-question-sign text-muted"></i></span>
          <input [(ngModel)]="model.hint" formControlName="hint" type="text" class="form-control" />
        </div>
      </div>
    </div>
    <div class="ui segment" appTabContent="2">
      <div *ngIf="model">
        <div class="field">
          <sui-checkbox formControlName="required">
            Require
          </sui-checkbox>
          <!-- <label>Require</label> <span data-toggle="tooltip" data-placement="right" title="Is this field mandatory?"><i class="glyphicon glyphicon-question-sign text-muted"></i></span>                  &nbsp;&nbsp;&nbsp;
                  <label class="inline">
                            <input type="checkbox" formControlName="required" class="ace"/>
                          <span class="lbl"></span>
                        </label> -->
        </div>
        <div formGroupName="constraintGroup">
          <div class="field">
            <label>Constraint</label> <span data-toggle="tooltip" data-placement="right"
              title="Add constraint to ensure data quality "><i
                class="glyphicon glyphicon-question-sign text-muted"></i></span>
            <select formControlName="constStatus" class="form-control"
              placeholder="select if you want to constraint this field">
              <option value="true">True</option>
              <option value="false">False</option>
            </select>
          </div>
          <div class="field">
            <label>Select condition operator</label> <span data-toggle="tooltip" data-placement="right"
              title="Select operator"><i class="glyphicon glyphicon-question-sign text-muted"></i></span>
            <select formControlName="constOperator" class="form-control" placeholder="">
              <option value="="> equal to </option>
              <option value="!="> not equal to </option>
              <option value=">"> greater than </option>
              <option value=">="> greater than or equal to </option>
              <option value="<"> less than </option>
              <option value="<="> less than or equal to </option>
            </select>
          </div>
          <div class="field">
            <label>Value</label> <span data-toggle="tooltip" data-placement="right"
              title="Enter the condition value, check the xlsForm website under constraint section for more information"><i
                class="glyphicon glyphicon-question-sign text-muted"></i></span>
            <input formControlName="constValue" class="form-control">
            <span
              [ngClass]="{ 'has-error' : modelForm.get('constraintGroup').get('constValue').dirty	&&	!modelForm.get('constraintGroup').get('constValue').valid}"
              *ngIf="modelForm.get('constraintGroup').get('constValue').dirty	&&	!modelForm.get('constraintGroup').get('constValue').valid  && !modelForm.get('constraintGroup').get('constValue').pending">
              <span class="help-block"
                *ngIf="modelForm.get('constraintGroup').get('constValue').hasError('constValue')">Only alphanumeric
                characters are allowed.</span>
            </span>
          </div>
        </div>
        <div class="field">
          <label>Constraint Message</label> <span data-toggle="tooltip" data-placement="right"
            title="Message telling the user why the answer is not accepted"><i
              class="glyphicon glyphicon-question-sign text-muted"></i></span>
          <input formControlName="constraint_message" type="text" class="form-control" />
        </div>
      </div>
    </div>
    <div class="ui segment" appTabContent="3">
      <div class="field">
        <label>Select choices source</label> <span data-toggle="tooltip" data-placement="right"
          title="Select operator"><i class="glyphicon glyphicon-question-sign text-muted"></i></span>
        <select [formControl]="choiceSource" (ngModelChange)="choicesChange($event)" class="form-control">
          <option value="csv"> import from csv </option>
          <option [selected]="true" value="manual">type choices manually </option>
        </select>
      </div>

      <div class="field" *ngIf="isImport">
        <label>Import choices from csv</label> <span data-toggle="tooltip" data-placement="right"
          title="Upload a csv format with label and value columns"><i
            class="glyphicon glyphicon-question-sign text-muted"></i></span>
        <input #uploadDoc type="file" id="id-input-file-2" accept=".csv" #uploader (change)="onCsv($event)"
          [formControl]="choiceImport" placeholder="Browse for documents" onclick="value = null" />

      </div>

      <div class="field" *ngIf="!isImport">
        <label class="col-sm-3">Enter choice</label>
        <input type="text" #ch class="col-sm-6" /> <button type="button" class="ui small primary button"
          (click)="addChoice(ch.value)">Add choice</button>
        <small *ngIf="choiceError" class="red2">choice name must be unique</small>
      </div>


      <div class="help-content" style="min-height:150px; padding:0px">
        <table class="table no-padding">
          <thead>
            <tr style="background-image:linear-gradient(to bottom, #f8f8f8 0, #f5f5f5 100%)">
              <th style="border-color:#6fb3e0"></th>
              <th style="border-color:#6fb3e0"></th>
              <th style="border-color:#6fb3e0"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Label</td>
              <td>Value</td>
              <td>Action </td>
            </tr>
            <tr *ngFor="let choice of choices; let i = index">
              <td style="padding:2px"><input type="text" value="{{choice.label}}" style="padding:2px"
                  (change)="editChoice($event,i)" /></td>
              <td style="padding:2px"><input type="text" value="{{choice.name}}" style="border:0px;padding:2px"
                  disabled="true" /></td>
              <td style="padding:2px">
                <button style="background:none; border:none;" (click)="deleteChoice(choice,i)">
                  <i class="trash icon"></i>
                </button>
              </td>
            </tr>
        </table>
      </div>
    </div>
    <div class="ui segment" appTabContent="4">
      <div *ngIf="model?.inputStyle !== 'calculate'" formGroupName="relevantGroup">
        <div class="field">
          <label>This field should display when this field component</label> <span data-toggle="tooltip"
            data-placement="right" title="The field component to test condition on"><i
              class="glyphicon glyphicon-question-sign text-muted"></i></span>
          <select formControlName="relComp" class="form-control">
            <option *ngFor="let com of selectComponents" value="{{com.field}}">{{com.field}}</option>
          </select>
        </div>
        <div class="field">
          <label>Select condition operator</label> <span data-toggle="tooltip" data-placement="right"
            title="Select operator"><i class="glyphicon glyphicon-question-sign text-muted"></i></span>
          <select formControlName="relOperator" class="form-control">
            <option value="="> equal to </option>
            <option value="!="> not equal to </option>
            <option value=">"> greater than </option>
            <option value=">="> greater than or equal to </option>
            <option value="<"> less than </option>
            <option value="<="> less than or equal to </option>
          </select>
        </div>
        <div class="field">
          <label>Value</label> <span data-toggle="tooltip" data-placement="right"
            title="Enter the condition value, check the xlsForm website under constraint section for more information"><i
              class="glyphicon glyphicon-question-sign text-muted"></i></span>
          <input formControlName="relValue" class="form-control">
          <span
            [ngClass]="{ 'has-error' : modelForm.get('relevantGroup').get('relValue').dirty	&&	!modelForm.get('relevantGroup').get('relValue').valid}"
            *ngIf="modelForm.get('relevantGroup').get('relValue').dirty	&&	!modelForm.get('relevantGroup').get('relValue').valid  && !modelForm.get('relevantGroup').get('relValue').pending">
            <span class="help-block" *ngIf="modelForm.get('relevantGroup').get('relValue').hasError('relValue')">Only
              alphanumeric characters are allowed.</span>
          </span>
        </div>
      </div>
    </div>
  </app-tabset>
</form>

<div class="actions" appMargin marginT="10">
  <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="center">
    <button class="ui basic primary button" (click)="onClose.emit()">Cancel</button>
    <button class="ui primary button" [disabled]="!modelForm.valid" autofocus (click)="continue()">Confirm</button>
    <!-- <button class="ui primary button" autofocus>Update</button> -->
  </div>
</div>
